import {
  toRef,
  watch,
} from 'vue';

import { useAppStore } from '@modules/core/store';

export default function waitAppReady(): Promise<void> {
  const isAppReady = toRef(useAppStore(), 'isAppReady');

  return new Promise<void>((resolve) => {
    if (isAppReady.value) {
      resolve();
      return;
    }

    const watchInitialized = watch(isAppReady, () => {
      watchInitialized();
      resolve();
    });
  });
}
